import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import css from "./form.module.css";
/**
 * The legend used in the formrow. Needed to pass accessibility.
 * @return the <legend /> html
 */
const FormRowLegend = ({ className, children, ...restProps }) => (_jsx("legend", { className: classNames(css.formRowLegend, className), ...restProps, children: children }));
FormRowLegend.displayName = 'FormRowLegend';
/**
 * Basic formrow that puts a 8px gap between the elements. Always use <FormRowLegend /> as first child to pass accessibility.
 * @return a div with flex gap 8px.
 */
const FormRow = ({ className, children, ...restProps }) => (_jsx("fieldset", { className: classNames(css.formRow, className), ...restProps, children: children }));
FormRow.displayName = 'FormRow';
/**
 * In case of multiple input fields in one form row, you need gaps between the different input columns
 * @returns flex-gap of 8px between the input columns.
 */
const InputsRow = ({ className, children, ...restProps }) => (_jsx("div", { className: classNames(css.inputsRow, className), ...restProps, children: children }));
InputsRow.displayName = 'InputsRow';
/**
 * In case of multiple input fields in one form row, you need to have a description on top.
 * The InputColumn puts a 4px gap between the description and input field.
 * @returns flex-gap 4px between children.
 */
const InputColumn = ({ className, children, ...restProps }) => (_jsx("div", { className: classNames(css.inputColumn, className), ...restProps, children: children }));
InputColumn.displayName = 'InputColumn';
export { FormRow, FormRowLegend, InputColumn, InputsRow };
